import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id AE565EF0-BC09-44FB-B94A-A5F2CF2B2CB2
 * name sign-pole
 * version: 5.4.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sign-pole.svg
 * tags
 */
export const SignPoleIcon = createSvgIcon(<><path d="M11 3L12 2L13 3V20C14.11 20 15 20.9 15 22H9C9 20.9 9.9 20 11 20V3Z" /></>, 'SignPoleIcon');
export default SignPoleIcon